<template>
  <div class="auxiliary-layout">
    <div class="header-wrap"><auxiliary-header></auxiliary-header></div>

    <div class="page-content-wrap">
      <transition name="down" mode="out-in">
        <router-view :key="$route.meta.category"></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
import AuxiliaryHeader from './AuxiliaryHeader.vue'

export default {
  components: {
    AuxiliaryHeader
  }
}
</script>

<style lang="less" scoped>
@import '../../style/mixin.less';
@import '../../style/variable.less';

.auxiliary-layout {
  height: 100%;
  width: 100%;
  overflow: hidden;
  position: relative;
  .header-wrap {
    height: @headerHeight;
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.2);
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    right: 0;
  }
  .page-content-wrap {
    margin-top: @headerHeight;
    height: calc(~'100% - @{headerHeight}');
    width: 100%;
    overflow: hidden;
    .default-header {
      width: 100%;
      line-height: 50px;
      font-size: 18px;
      font-weight: bolder;
      color: #333;
      box-shadow: 0 0 5px rgba(200, 200, 200, 0.6);
      text-indent: 1em;
    }
    .search-input {
      margin: 40px 25px;
    }
  }
}
</style>
